export default {"src":"/_next/static/media/ilu-watch-results.d13bb835.svg","height":220,"width":325};